/*
 * Convenience class for logic that is needed for displaying level media
 * (which explains the content of the current level).
 */
class LevelMedia {
	constructor(game) {
		this.game = game;
		this.mediaOverlay = this.game.el.querySelector('.LevelMediaOverlay');
		this.mediaOverlay.querySelector('.background').style.opacity = 0.8;
		this.mediaText = this.mediaOverlay.querySelector('.LevelMediaText');
		this.initializeListenersForOpeningMedia();
		this.initializeListenersForClosingMedia();
		this.closeMedia();
	}

	initializeListenersForClosingMedia() {
		this.game.safeObserve(this.mediaOverlay.querySelector('.levelTextClose'), 'click', this.onLevelMediaCloseButtonClick.bind(this));
	}

	onLevelMediaCloseButtonClick(ev) {
		this.closeMedia();
	}

	initializeListenersForOpeningMedia() {
		this.attachHandlerOnClickIfElementExists('.textMediaButton', this.onToLessonClick);
	}

	onToLessonClick(ev) {
		this.showMedia();
	}


	/**
	 * Public. Loads the given media.
	 */
	loadMedia(mediaText) {
		this.hasTextMedia = (mediaText != undefined) && (mediaText.text != undefined);

		if (this.hasTextMedia) {
			this.mediaText.innerHTML = mediaText.text;
			this.viewCount = 0;
			this.viewTimeSeconds = mediaText.viewTimeSeconds;
			this.secondViewTimeSeconds = mediaText.secondViewTimeSeconds;
		}
	}

	showMedia() {
		if (this.hasTextMedia) {
			var maximumDisplayTimeInSeconds = this.viewCound == 0 ? this.viewTimeSeconds : this.secondViewTimeSeconds;
			this.openMedia(maximumDisplayTimeInSeconds);
		}
	}

	closeMedia() {
		this.mediaOverlay.style.display = 'none';
		this.stopCountdown();
		var event = document.createEvent('Event');
		event.initEvent("closeMedia", true, true);
		this.game.el.dispatchEvent(event);
	}

	/**
	 * Makes the level media show up. null for maximumDisplayTimeInSeconds means unlimited.
	 */
	openMedia(maximumDisplayTimeInSeconds) {
		this.mediaOverlay.style.display = '';
		this.viewCount++;
		if (maximumDisplayTimeInSeconds != null) {
			this.startCountdown(maximumDisplayTimeInSeconds);
		}
	}

	/**
	 * Starts the countdown for displaying the level media; once the end of the 
	 * countdown is reached, the level media is automatically closed.
	 */
	startCountdown(time) {
		this.stopCountdown();
		this.secondsLeftToViewLeveMedia = time;
		this.countdown = setInterval(this.decreaseSecondsLeftToViewLevelMedia.bind(this), 1000);
		this.updateDisplayOfTimeLeftToViewLevelMedia();
	}

	stopCountdown() {
		if (this.countdown != undefined) {
			clearInterval(this.countdown);
			this.countdown = undefined;
		}
	}

	/**
	 * This decreases the time left to view the level media by one second; once it reaches 0, 
	 * the level media is closed.
	 */
	decreaseSecondsLeftToViewLevelMedia() {
		this.secondsLeftToViewLeveMedia--;
		this.updateDisplayOfTimeLeftToViewLevelMedia();
		if (this.secondsLeftToViewLeveMedia <= 0) {
			this.stopCountdown();
			this.closeMedia();
		}
	}

	updateDisplayOfTimeLeftToViewLevelMedia() {
		this.game.el.querySelector('.LevelMediaTimer').innerHTML = this.secondsLeftToViewLeveMedia;
	}

	attachHandlerOnClickIfElementExists(elementSelector, handlerCallback) {
		var selectedElement = this.game.el.querySelector(elementSelector);
		if (selectedElement != undefined) {
			this.game.safeObserve(selectedElement, 'click', handlerCallback.bind(this));
		}
	}
}
